enum PaymentStatus {
  Accepted = 'ACCEPTED',
}

export default PaymentStatus;
